import { useEffect, useState } from "react";
import { isPrerendering } from "@/lib/prerender_flag";

function shapeStyle(shape, size) {
  switch (shape) {
    case "circle":
      return { width: size, height: size, borderRadius: 9999 };
    case "rect-sharp":
      return { minWidth: size, padding: "18px 28px", borderRadius: 0 };
    case "rect-rounded":
      return { minWidth: size, padding: "18px 28px", borderRadius: 32 };
    case "diamond":
      return { width: size, height: size, borderRadius: 0, transform: "rotate(45deg)" };
    case "pentagon":
      return {
        width: size,
        height: size,
        clipPath: "polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)",
      };
    default:
      return { minWidth: size, padding: "18px 28px", borderRadius: 16 };
  }
}

export default function OnlineVisitorsPreview({ cfg, liveCount = null }) {
  const [count, setCount] = useState(liveCount ?? 42);

  useEffect(() => {
    if (liveCount !== null) {
      setCount(liveCount);
      return;
    }
    if (isPrerendering()) return undefined;
    const t = setInterval(() => {
      setCount((c) => Math.max(1, c + (Math.random() > 0.5 ? 1 : -1) * Math.ceil(Math.random() * 3)));
    }, 1800);
    return () => clearInterval(t);
  }, [liveCount]);

  const bg =
    cfg.bg_type === "gradient"
      ? `linear-gradient(135deg, ${cfg.bg_gradient_from}, ${cfg.bg_gradient_to})`
      : cfg.bg_color;
  const sStyle = shapeStyle(cfg.shape, cfg.size);
  const innerRotate = cfg.shape === "diamond" ? { transform: "rotate(-45deg)" } : {};

  return (
    <div
      data-testid="preview-online-visitors"
      style={{
        display: "inline-block",
        fontFamily: `${cfg.font}, monospace`,
        // v60.69 — CSS containment cuts document-wide reflow from
        // the live-count digit ticker + green pulse dot animation.
        contain: "layout style paint",
      }}
    >
      <div
        style={{
          ...sStyle,
          background: bg,
          color: cfg.text_color,
          boxShadow: "0 10px 28px rgba(0,0,0,.18)",
          border: cfg.border_width > 0 ? `${cfg.border_width}px solid ${cfg.border_color}` : "none",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
          transition: "transform .3s ease",
        }}
      >
        <div style={{ ...innerRotate, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
          <div style={{ fontSize: cfg.shape === "rect-sharp" || cfg.shape === "rect-rounded" ? 34 : 30, fontWeight: 800, lineHeight: 1 }}>
            {count.toLocaleString()}
          </div>
          {cfg.show_label !== false && (
            <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".15em", opacity: 0.95 }}>
              <span
                style={{ width: 8, height: 8, borderRadius: 9999, background: "#00E676", boxShadow: "0 0 8px #00E676" }}
                className="animate-blink-dot"
              />
              <span>{cfg.label_text || (({ es: "En línea", fr: "En direct", de: "Online", hi: "ऑनलाइन", pt: "Online", it: "Online", ru: "Онлайн", ja: "オンライン", zh: "在线", ar: "متصل", nl: "Online" }[cfg.lang]) || "Online")}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
